import React from "react";

import Layout from "../components/Layout";
import SEO from "../components/SEO";
import FAQ from "../components/FAQ";

function DoneForYouPage() {
  return (
    <Layout>
      <SEO title="FAQ" />
      <section className="w-full px-4 sm:max-w-6xl mx-auto py-16 min-h-screen">
        <FAQ />
      </section>
    </Layout>
  );
}

export default DoneForYouPage;